import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { SyosPriceLevel } from '../../../models/syos-price-level';
import { NgStyle, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
/**
 * @deprecate
 * **/
@Component({
    selector: 'lib-bi-tool-bar-price-level',
    templateUrl: './bi-tool-bar-price-level.component.html',
    styleUrls: ['./bi-tool-bar-price-level.component.css'],
    imports: [NgStyle, MatIcon, CurrencyPipe]
})
export class BiToolBarPriceLevelComponent implements OnInit {

    @Input() priceLevels: SyosPriceLevel [] = [];
    @Output() qtyEmitter = new EventEmitter<number>();
    qty = 2;

    constructor() {
    }

    ngOnInit() {

    }

    qtyMinusOnePl() {
        if (this.qty > 0) {
            this.qty--;
        }
        this.qtyEmitter.emit(this.qty)
    }

    qtyPlusOnePl() {
        this.qty++;
        this.qtyEmitter.emit(this.qty)
    }
}
